import {Palette} from 'hubbl-shared';
import styled from 'styled-components';
import {ReCaptchaProvider} from './components';
import {LoadingAnimation} from './components/loading-animation/LoadingAnimation';
import {RootNavigator} from './navigation/RootNavigator';
import {AuthProvider} from './store/AuthProvider';

// Continuously listen for screen size changes
const AppContainer = styled.div`
  background-color: ${Palette.primarySubtleGreen};
  height: 100%; /* Full height of the viewport */
  display: flex;
  flex-direction: column;
`;

export const App = () => {
  return (
    <ReCaptchaProvider>
      <AuthProvider>
        <AppContainer className="app">
          <main className="content">
            <RootNavigator />
          </main>
          <LoadingAnimation />
        </AppContainer>
      </AuthProvider>
    </ReCaptchaProvider>
  );
};
